module.exports = __webpack_public_path__ + "static/media/2000px-Flag_of_the_Turks_and_Caicos_Islands.svg_.a039a7c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assests/images/2000px-Flag_of_the_Turks_and_Caicos_Islands.svg_.png
// module id = 270
// module chunks = 2